import React from 'react';
import {
    Theme
} from '@material-ui/core';
import { StyleRules, createStyles, withStyles } from '@material-ui/core/styles';
import trimbleLogo from '../../assets/images/trimble_white.png';

interface TrimbleLogoProps {
    classes?: any;
}

const styles = (theme: Theme): StyleRules => {
    return createStyles({
        companyLogo: {
            maxHeight: '20px'
        },
        [theme.breakpoints.only('xs')]: {
            companyLogo: {
                maxWidth: '100px'
            }
        }
    });
};

const TrimbleLogo: React.FunctionComponent<TrimbleLogoProps> = (props: TrimbleLogoProps): JSX.Element => {
    return (
        <img className={props.classes.companyLogo} src={trimbleLogo} alt='Trimble Logo' />
    );
};

export default (withStyles(styles))(TrimbleLogo);
